import { MainNavigation } from "../components/MainNavigation";
import { Footer } from "../components/Footer";
import { Outlet, useNavigation } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchNavHeightAction } from "../store/general-store";
import store from "../store/store";
import { getSkeletonForPathname } from "../helpers/routeSkeletons";

export const MAX_FAVORITES = 25;

const Root = () => {
  const [navHeight, setNavHeight] = useState("");
  const navigation = useNavigation();

  useEffect(() => {
    const nav = document.getElementById("nav");
    const navHeight = nav.offsetHeight;
    setNavHeight(navHeight);
    store.dispatch(fetchNavHeightAction(navHeight));
  }, []);

  // React Router keeps the outgoing page's element mounted until the
  // destination's loader resolves, so a page picking its own skeleton off
  // `useNavigation().state` ends up showing *its own* skeleton while
  // navigating away, not the destination's - it's still the one on
  // screen. Root is the one place that stays mounted across every
  // transition, so it's what can look at `navigation.location` - the
  // pending destination, available while a navigation is in flight - and
  // show the skeleton for where the user is actually headed.
  const PendingSkeleton =
    navigation.state === "loading"
      ? getSkeletonForPathname(navigation.location.pathname)
      : null;

  return (
    <div>
      <MainNavigation></MainNavigation>
      {PendingSkeleton ? (
        <PendingSkeleton navHeight={navHeight} />
      ) : (
        <Outlet />
      )}
      <Footer></Footer>
    </div>
  );
};

export default Root;
